import { createFileRoute, Navigate } from "@tanstack/react-router";

/** Network merged into Catalog (/catalog) — keep URL for old links. */
export const Route = createFileRoute("/network")({
  component: NetworkRedirect,
});

function NetworkRedirect() {
  return <Navigate to="/catalog" replace />;
}
